import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const RegiaoCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [stateEstados, setStateEstados] = useState([]);

  const [state, setState] = useState({
    id: 0,
    estado_id: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    cep: "",
    latitude: "",
    longitude: "",
    descricao: "",
    ativo: true,
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-regiao").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/regiao", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/regiao");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a região.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarEstados = async () => {
    return await buscarDados("/estado");
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/regiao/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [estados, regiao] = await Promise.all([
          carregarEstados(),
          carregarDados(),
        ]);

        setStateEstados(estados);

        if (regiao) {
          setState(regiao);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da região");
      }
    };

    let validacao = window.$("#form-regiao").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Regiões"
        header="Cadastro da Região"
        action={{ titulo: "Voltar", link: "/regiao" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da região</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-regiao">
                      <div className="row">
                        <div className="col-lg-3" hidden>
                          <div className="form-group">
                            <label>Selecione o estado</label>
                            <select
                              className="form-control"
                              id="estado_id"
                              name="estado_id"
                              value={state.estado_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione um estado
                              </option>

                              {stateEstados
                                .sort((a, b) => (a.nome > b.nome ? 1 : -1))
                                .map((estado) => (
                                  <option key={estado.id} value={estado.id}>
                                    {estado.nome}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-7">
                          <div className="form-group">
                            <label>Descrição da região</label>
                            <input
                              type="text"
                              placeholder="Descrição da região"
                              className="form-control"
                              name="descricao"
                              value={state.descricao}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Status da região</label>
                            <select
                              className="form-control"
                              id="ativo"
                              name="ativo"
                              value={state.ativo}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="1" value={true}>
                                Ativo
                              </option>

                              <option key="2" value={false}>
                                Inativo
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row" hidden>
                        <div className="col-lg-5">
                          <div className="form-group">
                            <label>Endereço da região</label>
                            <input
                              type="text"
                              placeholder="Endereço da região"
                              className="form-control"
                              name="endereco"
                              value={state.endereco}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Número da região</label>
                            <input
                              type="text"
                              placeholder="Número da região"
                              className="form-control"
                              name="numero"
                              value={state.numero}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Complemento da região</label>
                            <input
                              type="text"
                              placeholder="Complemento da região"
                              className="form-control"
                              name="complemento"
                              value={state.complemento}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label>Bairro da região</label>
                            <input
                              type="text"
                              placeholder="Bairro da região"
                              className="form-control"
                              name="bairro"
                              value={state.bairro}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row" hidden>
                        <div className="col-lg-5">
                          <div className="form-group">
                            <label>Cidade da região</label>
                            <input
                              type="text"
                              placeholder="Cidade da região"
                              className="form-control"
                              name="cidade"
                              value={state.cidade}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Cep da região</label>
                            <input
                              type="text"
                              placeholder="Cep da região"
                              className="form-control"
                              name="cep"
                              value={state.cep}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Latitude da região</label>
                            <input
                              type="text"
                              placeholder="Latitude da região"
                              className="form-control"
                              name="latitude"
                              value={state.latitude}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label>Longitude da região</label>
                            <input
                              type="text"
                              placeholder="Longitude da região"
                              className="form-control"
                              name="longitude"
                              value={state.longitude}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default RegiaoCadastrar;
